import React from 'react';

import { SVGPropsType } from 'src/types';

function Info(props: SVGPropsType) {
    const { fill, size = 20, onClick, style, className } = props;

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={style}
            className={className}
        >
            <path
                d="M7.99984 0.666668C3.93317 0.666668 0.666504 3.93333 0.666504 8C0.666504 12.0667 3.93317 15.3333 7.99984 15.3333C12.0665 15.3333 15.3332 12.0667 15.3332 8C15.3332 3.93333 12.0665 0.666668 7.99984 0.666668ZM7.99984 14C4.6665 14 1.99984 11.3333 1.99984 8C1.99984 4.66667 4.6665 2 7.99984 2C11.3332 2 13.9998 4.66667 13.9998 8C13.9998 11.3333 11.3332 14 7.99984 14Z"
                fill={fill}
            />
            <path
                d="M7.99967 7.33334C7.59967 7.33334 7.33301 7.6 7.33301 8V10.6667C7.33301 11.0667 7.59967 11.3333 7.99967 11.3333C8.39967 11.3333 8.66634 11.0667 8.66634 10.6667V8C8.66634 7.6 8.39967 7.33334 7.99967 7.33334Z"
                fill={fill}
            />
            <path
                d="M7.99967 4.66667C7.59967 4.66667 7.33301 4.93333 7.33301 5.33333C7.33301 5.73333 7.66634 6 7.99967 6C8.33301 6 8.66634 5.73333 8.66634 5.33333C8.66634 4.93333 8.39967 4.66667 7.99967 4.66667Z"
                fill={fill}
            />
        </svg>
    );
}

export default Info;
